import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ListChecksIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-24 bg-transparent px-4 relative overflow-hidden" data-id="element-276">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-gradPurple/5 blur-[120px] rounded-full pointer-events-none" data-id="element-277" />

      <div className="max-w-6xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-278">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-6 max-w-4xl leading-tight" data-id="element-279">
          ¿Te sentís agobiado por la cantidad de tareas y fechas de entrega?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-textMuted max-w-3xl mb-16 font-medium" data-id="element-280">
          No saber por dónde empezar, postergar tareas y llegar con estrés a
          cada parcial es más común de lo que pensás.
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 w-full max-w-4xl" data-id="element-281">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-4 md:p-5 bg-[#1E1A2E] rounded-xl border border-white/10 hover:-translate-y-1 transition-transform duration-300" data-id="element-282">
            <div className="w-11 h-11 bg-[#FF6B00]/10 rounded-full flex items-center justify-center mb-4 border border-[#FF6B00]/20 shadow-[0_0_15px_rgba(255,107,0,0.15)]" data-id="element-283">
              <ClockIcon className="w-5 h-5 text-[#FF6B00]" data-id="element-284" />
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-285">
              Falta de tiempo para organizarte
            </h3>
            <p className="text-textMuted leading-relaxed text-sm" data-id="element-286">
              Sientes que las horas no alcanzan y siempre estás corriendo de
              atrás con las lecturas.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-4 md:p-5 bg-[#1E1A2E] rounded-xl border border-white/10 hover:-translate-y-1 transition-transform duration-300" data-id="element-287">
            <div className="w-11 h-11 bg-[#8A2BE2]/10 rounded-full flex items-center justify-center mb-4 border border-[#8A2BE2]/20 shadow-[0_0_15px_rgba(138,43,226,0.15)]" data-id="element-288">
              <ListChecksIcon className="w-5 h-5 text-[#8A2BE2]" data-id="element-289" />
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-290">
              Tareas acumuladas y sin priorizar
            </h3>
            <p className="text-textMuted leading-relaxed text-sm" data-id="element-291">
              La lista de pendientes crece y no sabés qué es lo más urgente o
              importante para resolver hoy.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center p-4 md:p-5 bg-[#1E1A2E] rounded-xl border border-white/10 hover:-translate-y-1 transition-transform duration-300" data-id="element-292">
            <div className="w-11 h-11 bg-[#FF0055]/10 rounded-full flex items-center justify-center mb-4 border border-[#FF0055]/20 shadow-[0_0_15px_rgba(255,0,85,0.15)]" data-id="element-293">
              <BrainIcon className="w-5 h-5 text-[#FF0055]" data-id="element-294" />
            </div>
            <h3 className="text-base font-bold text-white mb-2" data-id="element-295">
              Estrés antes de exámenes y parciales
            </h3>
            <p className="text-textMuted leading-relaxed text-sm" data-id="element-296">
              Llegas a la semana de parciales quemado, durmiendo poco y con la
              cabeza a mil por hora.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}